import React, { useState, useEffect } from "react";
import { Card,  Button, Modal} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { allCommentsReplies, deleteCommentReplies } from "../../../common/api";
import { ShowToast } from "../../../common/function";
import avatar1 from "../../../assets/img/default.jpg";
import ConfigApp from "../../../common/config";
import { Sentry, Spinner } from "react-activity";

export default function AllComments() {


  const location = useLocation();

  const commentId = location?.state?.commentId;
  console.log(commentId);
  const navigate = useNavigate();
  const [postId, setPostId] = useState(null);
  const [postData, setPostData] = useState({});
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [postIds, setPostIds] = useState("");
  const [loading, setLoading] = useState(false);
  const [fullscreenMedia, setFullscreenMedia] = useState(null); // store selected image/video
  const [showModal, setShowModal] = useState(false);
  const [key, setKey] = useState("comments");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setPostIds("");
  };

  const handleShow = (id) => {
    setShow(true);
    setPostIds(id);
  };

  // Store or retrieve postId
  useEffect(() => {
    const statePostId = location?.state?.postId;
    if (statePostId) {
      setPostId(statePostId);
      localStorage.setItem("view_post_id", statePostId);
    } else {
      const storedId = localStorage.getItem("view_post_id");
      if (storedId) {
        setPostId(storedId);
      } else {
        ShowToast(0, "Post ID not found. Redirecting...");
        navigate("/posts");
      }
    }
  }, []);

  useEffect(() => {
    if (postId) getParticularPost();
  }, [postId]);

  const getParticularPost = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    console.log(commentId);
    const response = await allCommentsReplies(token, { commentId });
    console.log(response);
    if (response.success === true) {
      setLoading(false);
      setPostData(response.body);
    } else {
      ShowToast(0, response.message || "Post fetch failed");
    }
  };

  const handleDeleteComment = async (id) => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    const response = await deleteCommentReplies(token, { commentReplyId: id });
    setIsLoading(false);
    if (response.success) {
      ShowToast(1, "Comment deleted successfully");
      getParticularPost();
      handleClose();
    }
  };
  const openFullscreen = (mediaUrl, isVideo) => {
    setFullscreenMedia({ url: mediaUrl, isVideo });
    setShowModal(true);
  };

  const getRelativeTime = (date) => {
    const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    const now = new Date();
    const created = new Date(date);
    const diffInSeconds = Math.floor((now - created) / 1000);
    const ranges = {
      year: 3600 * 24 * 365,
      month: 3600 * 24 * 30,
      week: 3600 * 24 * 7,
      day: 3600 * 24,
      hour: 3600,
      minute: 60,
      second: 1,
    };
    for (let key in ranges) {
      const delta = Math.floor(diffInSeconds / ranges[key]);
      if (isFinite(delta) && Math.abs(delta) > 0) {
        return rtf.format(-delta, key);
      }
    }
    return "just now";
  };

  const commentData =
  postData&&postData.length>0&& postData?.map((item, index) => ({
      id: index + 1,
      commentId: item._id,
      name: item.userDetails?.full_name || "Anonymous",
      imgurl: item.userDetails?.profile_url,
      comment: item.comment,
      timeOriginal: item.createdAt, // <-- Add this
      time: getRelativeTime(item.createdAt),
    })) || [];

  const filteredData = commentData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !==
      -1
  );

  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row.name,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={
              row.imgurl.startsWith("http")
                ? row.imgurl
                : row.imgurl
                ? `${ConfigApp.IMAGE_URL}${row.imgurl}`
                : avatar1
            }
            alt=""
            width={35}
            height={35}
          />
          {row.name ? row.name : "N/A"}
        </>
      ),
    },
    {
      name: "Comment",
      minWidth: "300px",
      cell: (row) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            paddingRight: "8px",
          }}
        >
          {row.comment || "N/A"}
        </div>
      ),
      wrap: true, // Optional: adds padding and allows wrapping
    },

    {
      name: "Time",
      minWidth: "180px",
      selector: (row) => row.time,
      cell: (row) => {
        const date = new Date(row.timeOriginal);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // Convert to 12-hour format

        const formatted = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
        return <>{formatted}</>;
      },
    },
    
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <Link className="btndelete" onClick={() => handleShow(row.commentId)}>
    //       <Icon icon="tabler:trash" />
    //     </Link>
    //   ),
    // },
  ];
  console.log('hi')

  return (
    <React.Fragment>
      {loading ? (
        <Sentry
          color="#2B5AAC"
          size={30}
          speed={1}
          animating={true}
          style={{ marginLeft: "45%", marginTop: "300px" }}
        />
      ) : (
        <>
          <Card>
          <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
              <h5>Comment Replies</h5>
              <Link
                className="btn btn-primary2 d-inline-flex align-items-center justify-content-center px-4 min_width140"
                to={"/posts/view-post"}
              >
                Back
              </Link>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                className="custom-table"
              />
            </Card.Body>
          </Card>

          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            centered
            dialogClassName="custom-fullscreen-modal"
          >
            <Modal.Body className=" bg-black position-relative d-flex justify-content-center align-items-center">
              {/* Close Button */}
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  zIndex: 10,
                  background: "rgba(0,0,0,0.5)",
                  border: "none",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  color: "#fff",
                  fontSize: 24,
                  lineHeight: "40px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>

              {fullscreenMedia?.isVideo ? (
                <video
                  src={fullscreenMedia.url}
                  controls
                  autoPlay
                  style={{
                    // maxWidth: "59%",
                    maxHeight: "95vh",
                    borderRadius: 10,
                  }}
                />
              ) : (
                <img
                  src={fullscreenMedia?.url}
                  alt="fullscreen-media"
                  className="fullscreen-image"
                  style={{
                    width: "100%",
                    borderRadius: 10,
                    height: "400px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Modal.Body>
          </Modal>
        </>
      )}

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleDeleteComment(postIds)}
          >
            {isLoading ? (
              <Spinner animation="border" variant="primary" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
